import React, { PureComponent, Suspense, lazy } from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';

const Visualiser = lazy(() => import('./containers/Visualiser/Visualiser'));


export default class App extends PureComponent {

  render() {
    return (
        <div style={{ height: 'inherit' }} className={'app'}>
          <div style={{ height: 'inherit' }} className={'appContent'}>
            <Suspense fallback={() => null as any}>
                <BrowserRouter>
                  <Switch>
                    <Route component={Visualiser} />
                  </Switch>
                </BrowserRouter>
            </Suspense>
          </div>
        </div>
    );
  }
}
